import React from "react"
import { Card } from "antd"

export default function AllergyCard({ allergyData }) {

  return (
    <Card
      title="Allergies"
      className="patient-card my-2"
    >
      {allergyData && allergyData.length > 0 ? (
        <ul className="m-0 p-0">
          {allergyData.length > 0 &&
            allergyData.map((allergy) => (
              <li className="m-0 ml-3 p-0" key={allergy.id}>
                {allergy.type} - {allergy.name}
              </li>
            ))}
        </ul>
      ) : (
        <h6 className="center">No Allergies Found</h6>
      )}
    </Card>
  )
}
